import {
  ExternalIntegration,
  ExternalIntegrationEnum,
  FacebookProfile,
  InstagramProfile,
  LinkedInProfile,
  TikTokProfile,
  WordPressProfile,
  XProfile,
  YouTubeProfile,
} from 'api/clients/ExternalIntegrationsClient'
import { Facebook, Instagram, LinkedIn, Twitter } from 'almanac-ui/icons'
import WordPressLogo from 'almanac-ui/icons/24/WordPressLogo'
import { GoHighLevel, Google, GoogleDrive, Mailchimp, Shopify, TikTok, Wix, YouTube } from 'blaze-ui/icons'
import { absurd } from 'types'
import MetaBrand from 'blaze-ui/icons/20/MetaBrand'

export const getPropsFromIntegration = (integration: ExternalIntegration) => {
  const { provider } = integration
  switch (provider) {
    case ExternalIntegrationEnum.LinkedIn:
      return {
        name: integration.name || (integration.additional_data as LinkedInProfile).name,
        icon: <LinkedIn size={24} />,
        avatarUrl: integration.picture || (integration.additional_data as LinkedInProfile).picture,
      }
    case ExternalIntegrationEnum.Instagram:
      return {
        name: integration.name || (integration.additional_data as InstagramProfile).name,
        icon: <Instagram size={24} />,
        avatarUrl: integration.picture || (integration.additional_data as InstagramProfile).profile_picture_url,
        details: `@${(integration.additional_data as InstagramProfile).username}`,
      }
    case ExternalIntegrationEnum.Facebook:
      return {
        name: integration.name || (integration.additional_data as FacebookProfile).name,
        icon: <Facebook size={24} />,
        avatarUrl: integration.picture || (integration.additional_data as FacebookProfile).picture.data.url,
      }
    case ExternalIntegrationEnum.X:
      return {
        name: integration.name || (integration.additional_data as XProfile).name,
        icon: <Twitter size={24} />,
        avatarUrl: integration.picture || (integration.additional_data as XProfile).profile_image_url,
        details: `@${(integration.additional_data as XProfile).username}`,
      }
    case ExternalIntegrationEnum.WordPress:
      return {
        name: (integration.additional_data as WordPressProfile).url,
        icon: <WordPressLogo size={24} />,
      }
    case ExternalIntegrationEnum.TikTok:
      return {
        name: integration.name,
        icon: <TikTok size={24} />,
        avatarUrl: integration.picture,
        details: `@${(integration.additional_data as TikTokProfile).username}`,
      }
    case ExternalIntegrationEnum.YouTube:
      return {
        name: integration.name,
        icon: <YouTube size={24} />,
        avatarUrl: integration.picture,
        details: (integration.additional_data as YouTubeProfile).username,
      }
    case ExternalIntegrationEnum.Mailchimp:
      return {
        name: integration.additional_data?.account_name,
        icon: <Mailchimp size={24} />,
        avatarUrl: integration.additional_data?.avatar_url,
        details: integration.additional_data?.username,
      }
    case ExternalIntegrationEnum.Google:
      return {
        name: integration.name,
        icon: <Google size={24} />,
        avatarUrl: undefined,
        details: undefined,
      }
    case ExternalIntegrationEnum.GoogleDrive:
      return {
        name: integration.name,
        icon: <GoogleDrive size={24} />,
        avatarUrl: undefined,
        details: undefined,
      }
    case ExternalIntegrationEnum.MetaAds:
      return {
        name: integration.name,
        icon: <MetaBrand size={24} />,
        avatarUrl: undefined,
        details: undefined,
      }
    case ExternalIntegrationEnum.GoHighLevel:
      return {
        name: integration.name,
        icon: <GoHighLevel size={24} />,
        avatarUrl: undefined,
        details: undefined,
      }
    case ExternalIntegrationEnum.Wix:
      return {
        name: integration.name,
        icon: <Wix size={24} />,
        avatarUrl: undefined,
        details: undefined,
      }
    case ExternalIntegrationEnum.Shopify:
      return {
        name: integration.name,
        icon: <Shopify size={24} />,
        avatarUrl: undefined,
        details: undefined,
      }
    default:
      absurd(provider)
      throw new Error('Invalid provider')
  }
}
